const Chevron = () => (
    <svg
        width='15'
        height='9'
        viewBox='0 0 15 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='chevron-icon'
    >
        <path
            d='M1 1.03601L7.5 7.03601L14 1.03601'
            stroke='#FFFFFF'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default Chevron;
